export default __webpack_public_path__ + "static/media/Slide 5.78af53ae.png";